import React from 'react';
import { useTranslation } from 'react-i18next';

import '../i18n/config';
import { Button } from '../Button';

interface Props {
  partner: string;
  partnerLogo: string;
  creditBalance: number;
  creditsTransferred: number;
  setShowDetails(value: boolean): void;
  setSuccessfulTransfer(value: boolean): void;
  trackingCallback(event: string, params?: Record<string, unknown>): Promise<void>;
}

export const StepOneSummary = ({
  partner,
  partnerLogo,
  creditBalance,
  creditsTransferred,
  setShowDetails,
  setSuccessfulTransfer,
  trackingCallback,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  const handleShowDetailsClicked = (): void => {
    setSuccessfulTransfer(false);
    setShowDetails(true);

    const trackingProps = {
      elementText: t('components.partnerWithCredits.transfer'),
    };

    trackingCallback('clicked-button', trackingProps);
  };

  const handleLinkClick = (): void => {
    const trackingProps = {
      elementText: `Learn more ${partner}`,
    };

    trackingCallback('clicked-button', trackingProps);
  };

  return (
    <>
      <p className='text-sm'>{t(`components.partnerWithCredits.${partner.toLowerCase()}.intro`)}</p>
      {creditBalance > 0 && (
        <Button
          className='font-bold mt-3 text-sapphire underline decoration-2 underline-offset-2'
          onClick={handleShowDetailsClicked}
        >
          {t('components.partnerWithCredits.transfer')}
        </Button>
      )}
      <div className='table mt-3'>
        <div className='table-row'>
          <div className='table-cell'>
            <span>{t('components.partnerWithCredits.creditBalance')}</span>
          </div>
          <div className='table-cell pl-4 font-bold'>${creditBalance}</div>
        </div>
        <div className='table-row'>
          <div className='table-cell'>
            <span>{t('components.partnerWithCredits.creditsTransferred')}</span>
          </div>
          <div className='table-cell pl-4 font-bold'>${creditsTransferred}</div>
        </div>
      </div>
      <a
        href={t(`components.partnerWithCredits.${partner.toLowerCase()}.baseUrl`) || ''}
        target='_blank'
        className='text-center'
        rel='noreferrer'
        onClick={handleLinkClick}
      >
        <div className='inline-block bg-emerald-50 mt-3 mx-auto pt-2 pb-3 px-4 rounded-full'>
          <span className='text-xs uppercase tracking-wider text-black'>{t('components.partnerWithCredits.learnMore')}</span>
          <img
            className='inline-block ml-2 max-w-[142px]'
            src={partnerLogo}
            alt={t('components.partnerWithCredits.logoAlt', { partner })}
          />
        </div>
      </a>
    </>
  );
};
